var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5116 21.1901C32.4913 20.7834 31.9939 19.6266 32.4006 18.6063L35.3317 11.2529C35.7384 10.2326 36.8952 9.7352 37.9155 10.1419C38.9358 10.5486 39.433 11.7052 39.0263 12.7255L36.0952 20.0789C35.6888 21.0993 34.532 21.5968 33.5116 21.1901Z",
    fill: "url(#paint0_linear_5150_3818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0845 49.8581C21.0642 49.4514 20.5668 48.2947 20.9734 47.2744L23.9044 39.9212C24.3111 38.9009 25.4678 38.4037 26.4881 38.8104C27.5085 39.2171 28.0056 40.3738 27.5991 41.3938L24.668 48.7472C24.2616 49.7674 23.1048 50.2648 22.0845 49.8581Z",
    fill: "url(#paint1_linear_5150_3818)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.641 20.2463C23.8579 20.7507 24.2588 21.1195 24.7316 21.3079C25.2043 21.4964 25.749 21.5045 26.2534 21.2876C27.2624 20.8539 27.7287 19.6841 27.2947 18.6752L24.1675 11.4029C23.7337 10.3941 22.5639 9.92782 21.5551 10.3616C20.546 10.7953 20.0797 11.9651 20.5138 12.974L23.641 20.2463Z",
    fill: "url(#paint2_linear_5150_3818)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9231 49.6593C36.4503 49.4709 36.0494 49.1021 35.8325 48.5977L32.7053 41.3254C32.2713 40.3165 32.7376 39.1467 33.7466 38.713C34.7554 38.2792 35.9252 38.7455 36.359 39.7543L39.4862 47.0266C39.9203 48.0355 39.454 49.2053 38.4449 49.639C37.9405 49.8559 37.3959 49.8478 36.9231 49.6593Z",
    fill: "url(#paint3_linear_5150_3818)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2527 24.6685L18.6063 27.5996C19.6266 28.0063 20.7832 27.5085 21.1898 26.4885C21.5964 25.4684 21.0992 24.3117 20.0789 23.905L12.7254 20.974C11.7053 20.5674 10.5486 21.0646 10.1419 22.0849C9.73523 23.1052 10.2324 24.2619 11.2527 24.6685Z",
    fill: "url(#paint4_linear_5150_3818)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2743 39.0264L39.921 36.0955C38.9007 35.6888 38.4033 34.532 38.81 33.5117C39.2167 32.4915 40.3734 31.9943 41.3937 32.401L48.7472 35.332C49.7675 35.7387 50.2647 36.8954 49.8581 37.9154C49.4515 38.9355 48.2946 39.4331 47.2743 39.0264Z",
    fill: "url(#paint5_linear_5150_3818)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.361 38.4451C10.5779 38.9495 10.9788 39.3182 11.4516 39.5067C11.9243 39.6951 12.469 39.7033 12.9734 39.4864L20.2459 36.3592C21.2549 35.9255 21.7212 34.7557 21.2872 33.7469C20.8534 32.7381 19.6835 32.2718 18.6747 32.7056L11.4023 35.8327C10.3932 36.2664 9.92694 37.4362 10.361 38.4451Z",
    fill: "url(#paint6_linear_5150_3818)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8034 27.3153C39.3307 27.1269 38.9298 26.7581 38.7129 26.2537C38.2788 25.2448 38.7451 24.0751 39.7542 23.6414L47.0266 20.5142C48.0354 20.0804 49.2052 20.5467 49.639 21.5555C50.0731 22.5644 49.6068 23.7342 48.5977 24.1679L41.3253 27.295C40.8209 27.5119 40.2762 27.5038 39.8034 27.3153Z",
    fill: "url(#paint7_linear_5150_3818)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5008 36.2711C30.9643 37.6516 34.8911 35.9631 36.2716 32.4997C37.6521 29.0363 35.9636 25.1096 32.5001 23.7291C29.0367 22.3486 25.1099 24.0372 23.7294 27.5005C22.3489 30.9639 24.0374 34.8906 27.5008 36.2711Z",
    fill: "url(#paint8_linear_5150_3818)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5150_3818",
    x1: 50,
    y1: 10,
    x2: 18.6667,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360652,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.5d06b7954f38d8807ede1ee40c707099.svg";
export { ForwardRef as ReactComponent };